import { Inject, Injectable } from '@angular/core';
import { map, Observable, of, tap } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AdhesionProductModel } from '../../../helpers/objects/dto/sales-portal/adhesion-product/adhesion-product-model';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';

@Injectable({
  providedIn: 'root'
})
export class ProductsAdhesionService {
  appConfig: EnvironmentModel = new EnvironmentModel();
  private readonly selectedApi : string = '';

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel
  ) {
    this.appConfig = appConfigTemp;
    if(this.appConfig.platform === 'fhps'){
      this.selectedApi = this.appConfig.api + 'external/'
    } else {
      this.selectedApi = this.appConfig.api
    }
  }

  getProductData(product: string, contractStartDate?: string, productPageGroup?: string): Observable<AdhesionProductModel> {
    const url = `${this.selectedApi}subscription/${this.appConfig.apiPartnershipId}/products/${encodeURIComponent(product)}`;

    let params = new HttpParams();

    if (contractStartDate) {
      params = params.set('contractStartDate', contractStartDate);
    }

    if (productPageGroup) {
      params = params.set('productPageGroup', productPageGroup);
    }

    return this.http.get<any>(url, { params }).pipe(
      map((response) => response.body as AdhesionProductModel)
    );
  }
}
